import * as _ from '../product/productbase.model';
export class OrderModel extends _.ProductBaseModel
{
    // line_type: string
    sales_ind: number
}


// WEBPACK FOOTER //
// ./src/models/order/order.model.ts